var _title, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPinterest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-labelledby": "pinterestTitle pinterestDesc",
    viewBox: "0 0 49.54 64"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Compartilhar no pinterest")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M26.27 0C8.81 0 0 12.52 0 22.97c0 6.32 2.39 11.95 7.53 14.04.84.35 1.6.01 1.84-.92.17-.64.57-2.27.75-2.95.25-.92.15-1.24-.53-2.05-1.48-1.74-2.43-4-2.43-7.21 0-9.29 6.95-17.61 18.1-17.61 9.87 0 15.3 6.03 15.3 14.09 0 10.6-4.69 19.55-11.65 19.55-3.84 0-6.72-3.18-5.8-7.08 1.11-4.66 3.25-9.68 3.25-13.05 0-3.01-1.62-5.52-4.96-5.52-3.93 0-7.09 4.07-7.09 9.52 0 3.47 1.17 5.82 1.17 5.82s-4.02 17.05-4.73 20.03c-1.4 5.95-.21 13.23-.11 13.97.06.44.62.54.88.21.36-.47 5.05-6.25 6.64-12.03.45-1.63 2.59-10.1 2.59-10.1 1.28 2.44 5.01 4.58 8.98 4.58 11.82 0 19.83-10.77 19.83-25.19C49.55 10.15 40.31 0 26.27 0z"
  })));
}

export default SvgPinterest;